export default __webpack_public_path__ + "static/media/pack-rare.844bc2b3.png";